import React from 'react';
import { getMultipleRandomHeadshots, getHeadshotPath } from './utils';
import { useLanguage } from '../context/LanguageContext';

/**
 * Testimonials specifically focused on coaching and speaking services
 */
const ServiceTestimonials = () => {
  // Get 2 different headshots for testimonials
  const headshots = getMultipleRandomHeadshots(2);
  const { t } = useLanguage();

  return (
    <section id="testimonials" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4 text-center">
          {t('testimonialsTitle')}
        </h2>
        <p className="font-accent text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto font-light leading-relaxed">
          {t('testimonialsSubtitle')}
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Coaching Testimonial */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="flex flex-col sm:flex-row sm:items-center mb-6">
              <img
                src={getHeadshotPath(headshots[0])}
                alt="Sarah Johnson"
                className="w-20 h-20 rounded-full object-cover mb-4 sm:mb-0 sm:mr-6 mx-auto sm:mx-0"
              />
              <div className="text-center sm:text-left">
                <div className="bg-blue-800 text-white text-xs uppercase font-bold py-1 px-2 rounded mb-1 inline-block">
                  {t('coaching')}
                </div>
                <h3 className="font-bold text-xl">Sarah Johnson</h3>
                <p className="text-gray-600">CEO, TechInnovate</p>
              </div>
            </div>
            <p className="font-accent text-gray-700 italic text-lg mb-4 leading-relaxed">
              "Tudor's coaching has been transformative for both my business and leadership approach. His ability to identify the real barriers to growth and provide practical solutions is remarkable. Revenue is up 300% and my team has never been more engaged."
            </p>
            <div className="flex items-center justify-end">
              <span className="inline-block bg-blue-100 text-blue-800 rounded-full px-3 py-1 text-sm font-semibold">
                Leadership • Growth • Team Building
              </span>
            </div>
          </div>

          {/* Speaking Testimonial */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="flex flex-col sm:flex-row sm:items-center mb-6">
              <img
                src={getHeadshotPath(headshots[1])}
                alt="Michael Chen"
                className="w-20 h-20 rounded-full object-cover mb-4 sm:mb-0 sm:mr-6 mx-auto sm:mx-0"
              />
              <div className="text-center sm:text-left">
                <div className="bg-yellow-500 text-black text-xs uppercase font-bold py-1 px-2 rounded mb-1 inline-block">
                  {t('speaking')}
                </div>
                <h3 className="font-bold text-xl">Michael Chen</h3>
                <p className="text-gray-600">Conference Director, FutureTech</p>
              </div>
            </div>
            <p className="font-accent text-gray-700 italic text-lg mb-4 leading-relaxed">
              "Tudor was the highlight of our annual conference. His keynote on strategic growth was both inspirational and practical. Attendees were still discussing his frameworks months later, and several have implemented his strategies with measurable results."
            </p>
            <div className="flex items-center justify-end">
              <span className="inline-block bg-yellow-100 text-yellow-800 rounded-full px-3 py-1 text-sm font-semibold">
                Keynote • Strategy • Innovation
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceTestimonials;